import React from 'react';
import { SvgIcon } from '@material-ui/core';

export const ColorPickerIcon = (props: any) => (
 <SvgIcon {...props}>
  <svg width='30' height='30' viewBox='0 0 38 38' fill='none' xmlns='http://www.w3.org/2000/svg'>
   <path
    d='M15.0176 0C6.72659 0 0.0175781 6.70901 0.0175781 15C0.0175781 23.291 6.72659 30 15.0176 30C23.3086 30 30.0176 23.291 30.0176 15C30.0176 6.70901 23.3086 0 15.0176 0ZM11.2676 15C11.2676 12.9272 12.9448 11.25 15.0176 11.25C17.0904 11.25 18.7676 12.9272 18.7676 15C18.7676 17.0728 17.0904 18.75 15.0176 18.75C12.9448 18.75 11.2676 17.0728 11.2676 15Z'
    fill='#FDF49D'
   />
   <path d='M3.75 15H0C0 20.5568 3.01382 25.4026 7.49759 27.9946L9.36875 24.7433C6.00839 22.7987 3.75 19.1658 3.75 15Z' fill='#F7D600' />
   <path
    d='M15.0005 3.75C17.0551 3.75 18.98 4.29966 20.6368 5.25966L22.5029 2.00541C20.2966 0.73002 17.7347 0 15.0005 0C12.2662 0 9.70428 0.73002 7.49805 2.00541L9.38104 5.2497C11.0341 4.2958 12.9529 3.75 15.0005 3.75Z'
    fill='#FF5DAA'
   />
   <path d='M9.38058 5.24966L7.49759 2.00537C3.01382 4.59738 0 9.4432 0 15H3.75C3.75 10.8293 6.01364 7.19259 9.38058 5.24966Z' fill='#FF8911' />
   <path
    d='M15.0005 26.2494C12.948 26.2494 11.0249 25.7009 9.36921 24.7427L7.49805 27.994C9.70428 29.2694 12.2662 29.9994 15.0005 29.9994C17.7347 29.9994 20.2966 29.2694 22.5029 27.994L20.6267 24.7456C18.9722 25.702 17.0509 26.2494 15.0005 26.2494Z'
    fill='#27E680'
   />
   <path
    d='M22.5028 2.00537L20.6367 5.25962C23.9942 7.20497 26.2504 10.8363 26.2504 15H30.0004C30.0004 9.4432 26.9866 4.59738 22.5028 2.00537Z'
    fill='#976DFD'
   />
   <path
    d='M20.627 24.7463L22.5031 27.9946C26.9869 25.4026 30.0007 20.5568 30.0007 15H26.2507C26.2507 19.1678 23.9901 22.8024 20.627 24.7463Z'
    fill='#6BDCFF'
   />
   <path d='M11.2636 8.49429L9.38058 5.25C6.0137 7.19294 3.75 10.8296 3.75 15.0003H7.5C7.5 12.2157 9.01352 9.78815 11.2636 8.49429Z' fill='#FFA54B' />
   <path
    d='M14.9994 22.5006C13.6286 22.5006 12.3444 22.1335 11.2393 21.4927L9.36816 24.744C11.0238 25.7022 12.9469 26.2507 14.9994 26.2507C17.0499 26.2507 18.9711 25.7033 20.6256 24.7469L18.7495 21.4986C17.6466 22.1359 16.3661 22.5006 14.9994 22.5006Z'
    fill='#60F7A6'
   />
   <path d='M7.5 15H3.75C3.75 19.1657 6.00839 22.7987 9.36875 24.7433L11.2399 21.492C9.00296 20.1948 7.5 17.7747 7.5 15Z' fill='#FFEB17' />
   <path
    d='M18.75 21.4979L20.6262 24.7463C23.9893 22.8024 26.2499 19.1678 26.2499 15H22.4999C22.4999 17.7788 20.9925 20.2021 18.75 21.4979Z'
    fill='#93E5FF'
   />
   <path
    d='M9.38086 5.24964L11.2639 8.49392C12.3636 7.86151 13.6393 7.49994 15.0003 7.49994C16.3753 7.49994 17.6631 7.8693 18.7705 8.5139L20.6366 5.25966C18.9798 4.29966 17.0549 3.75 15.0003 3.75C12.9527 3.74994 11.0339 4.29573 9.38086 5.24964Z'
    fill='#FF77B7'
   />
   <path
    d='M22.5003 15.0001H26.2503C26.2503 10.8364 23.9941 7.20518 20.6366 5.25977L18.7705 8.51401C21.0018 9.81276 22.5003 12.2296 22.5003 15.0001Z'
    fill='#AC8BFD'
   />
   <path
    d='M14.9994 18.7507C14.3103 18.7507 13.6655 18.5644 13.1108 18.2407L11.2393 21.4927C12.3444 22.1336 13.6285 22.5006 14.9993 22.5006C16.366 22.5006 17.6465 22.1359 18.7494 21.4986L16.8727 18.2494C16.3216 18.5677 15.6823 18.7507 14.9994 18.7507Z'
    fill='#A0F7C9'
   />
   <path
    d='M16.873 18.2488L18.7497 21.498C20.9922 20.2021 22.4996 17.7789 22.4996 15H18.7496C18.7496 16.3899 17.9949 17.601 16.873 18.2488Z'
    fill='#BFF0FF'
   />
   <path d='M7.5 15.0006H11.25C11.25 13.6022 12.014 12.3847 13.1472 11.74L11.2636 8.49463C9.01352 9.78849 7.5 12.2161 7.5 15.0006Z' fill='#FFBD7A' />
   <path
    d='M18.7495 15.0002H22.4995C22.4995 12.2297 21.001 9.81285 18.7697 8.51416L16.9033 11.7689C18.0084 12.4209 18.7495 13.6229 18.7495 15.0002Z'
    fill='#BDA2FD'
   />
   <path
    d='M14.9991 11.2501C15.6945 11.2501 16.345 11.4396 16.9029 11.7688L18.7693 8.51396C17.6619 7.86942 16.3741 7.5 14.9991 7.5C13.6381 7.5 12.3624 7.86157 11.2627 8.49398L13.1464 11.7394C13.6929 11.4285 14.3247 11.2501 14.9991 11.2501Z'
    fill='#FFA6DD'
   />
  </svg>
 </SvgIcon>
);
